<template>
    <div :class="numberIndicatorVariants({ variant, size, disabled, outline })">
        {{ badge }}{{ suffix ? `${suffix}` : '' }}
    </div>
</template>

<script setup lang="ts">
import { numberIndicatorVariants } from './indicatorVariants'
import type { NumberIndicatorProps } from './types'

defineProps<NumberIndicatorProps>()
</script>
